import { Input } from "@/components/ui/input";

const COST_ITEM_ROWS = 5;

/** 5 rows of Quantity / Product-Service / Cost estimate (Rp), stored as an array of
 * {qty, desc, cost}. Blank rows are simply skipped by the backend when rendering the
 * WhatsApp message, so admins don't have to fill all 5. */
export function CostItemsField({ testid, value, onChange }) {
  const rows = Array.from({ length: COST_ITEM_ROWS }, (_, i) => value[i] || { qty: "", desc: "", cost: "" });
  const updateRow = (i, patch) => {
    onChange(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  };
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-[70px_1fr_130px] gap-2 text-[11px] font-bold uppercase tracking-wide text-zinc-500 px-1">
        <span>Qty</span><span>Product / Service</span><span>Cost estimate (Rp)</span>
      </div>
      {rows.map((row, i) => (
        <div key={i} className="grid grid-cols-[70px_1fr_130px] gap-2">
          <Input data-testid={`${testid}-qty-${i}`} type="number" min="0" value={row.qty}
            onChange={(e) => updateRow(i, { qty: e.target.value })}
            className="rounded-xl bg-zinc-50 border-zinc-200 h-10 text-sm" placeholder="1" />
          <Input data-testid={`${testid}-desc-${i}`} type="text" value={row.desc}
            onChange={(e) => updateRow(i, { desc: e.target.value })}
            className="rounded-xl bg-zinc-50 border-zinc-200 h-10 text-sm" placeholder="e.g. Battery replacement" />
          <Input data-testid={`${testid}-cost-${i}`} type="number" min="0" value={row.cost}
            onChange={(e) => updateRow(i, { cost: e.target.value })}
            className="rounded-xl bg-zinc-50 border-zinc-200 h-10 text-sm" placeholder="0" />
        </div>
      ))}
    </div>
  );
}
